export const culturaOrganizativa_item = [
    {
        "cultura_item_nombre" : "Misión",
        "cultura_item_descripcion" : "La Unidad de Planeación y Prospectiva es una dependencia del Poder Ejecutivo, encargada del proceso de planeación del desarrollo estatal, basándose en instrumentos y mecanismos de        políticas públicas con un enfoque estratégico y prospectivo para impulsar el desarrollo en el Estado."
    },
    {
        "cultura_item_nombre" : "Visión",
        "cultura_item_descripcion" : "Mejorar las condiciones de bienestar de la población hidalguense a través de la evaluación y seguimiento a los instrumentos de planeación para asegurar el cumplimiento de los objetivos de política pública"
    },
    {
        "cultura_item_nombre" : "Objetivo General",
        "cultura_item_descripcion" : "Coordinar los procesos de planeación para el desarrollo, así como de monitoreo y evaluación de las políticas públicas."
    }
    
        
]